var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.2C2 14.2611 2.7835 13.5 3.75 13.5H14.25C15.2165 13.5 16 14.2611 16 15.2C16 18.9555 12.866 22 9 22C5.13401 22 2 18.9555 2 15.2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.4C12.5 10.2778 10.933 11.8 9 11.8C7.067 11.8 5.5 10.2778 5.5 8.4C5.5 6.52223 7.067 5 9 5C10.933 5 12.5 6.52223 12.5 8.4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.14286C10 2.51167 10.5373 2 11.2 2H18.4C19.0627 2 19.6 2.51167 19.6 3.14286V4.66667L21.0672 3.73512C21.4659 3.48196 22 3.75418 22 4.21058V7.78942C22 8.24582 21.4659 8.51804 21.0672 8.26488L19.6 7.33333V8.85714C19.6 9.48833 19.0627 10 18.4 10H13.7288C13.9043 9.50052 14 8.96272 14 8.4C14 5.99796 12.2566 4.04996 10 3.59872V3.14286Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/video-call.350171e89b6fcc19f4541bad5121d69a.svg";
export { ForwardRef as ReactComponent };